import { presets } from './presets';


export function createConfig(...cfg) {
    return Object.assign({}, presets, ...cfg);
};



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/plugins/vue-log/create-config.js